import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import { Input as AntInput } from "antd";
import Button from "components/BaseWidgets/button";

function Password({
  id,
  placeholder,
  label,
  value,
  onChange,
  className,
  labelClass,
  InputClassName,
  showForgot = false,
  onForgotClick,
  isPreventAutoFill,
}) {
  return (
    <div className={`flex flex-col w-full gap-1 ${className}`}>
      {label && (
        <div className=" flex justify-between items-center">
          <label
            className={`input-label ${labelClass ? labelClass : ""}`}
            htmlFor={id}
          >
            {label}
          </label>
          {showForgot && (
            <Button
              className="register-link"
              variant="link"
              onClick={onForgotClick}
              href={"/forgot"}
            >
              Forgot password?
            </Button>
          )}
        </div>
      )}
      <AntInput.Password
        id={id}
        placeholder={placeholder}
        className={`input-password ${InputClassName}`}
        value={value}
        onChange={onChange}
        iconRender={(visible) =>
          visible ? <EyeOutlined /> : <EyeInvisibleOutlined />
        }
        autoComplete={isPreventAutoFill && "new-password"}
      />
    </div>
  );
}

export default Password;
